<template>
  <div v-show="taskData">
    <el-drawer :visible.sync="visible" :before-close="cancel" size="600px">
      <div class="drawer-content">
        <!-- 提示：子组件的drawer没用，绑定的是visible值，可删此页面drawer -->
        <!-- <div class="drawerBox">
        <el-row>
          <el-col :span="19">
            <div class="taskTitle">{{ taskData.task_name }}</div>
          </el-col> -->
        <!-- <el-col :span="5">
            <el-button
              v-if="activeLabel=='待我确认' && taskData.confirm[0].workcode == this.$store.getters.username"
              type="primary"
              size="small"
              @click="submitDone"
            >确认完成</el-button>
            <el-button
              v-if="activeLabel!=='待我确认'&&activeLabel!=='执行完成'&& taskData.executor[0].workcode == this.$store.getters.username"
              type="primary"
              size="small"
              @click="dialogVisible = true"
            >执行完成</el-button>
             <el-button type="primary" size="small" v-if="activeLabel==='待我确认'">确认完成</el-button>
          </el-col> -->
        <!-- </el-row> -->
        <!-- <el-row>
          <el-col :span="12">
            <span>
              <i class="el-icon-user icons"/>
              负责人
            </span>&nbsp;&nbsp;
            <el-tag
              v-if="taskData.executor.length!==0"
              size="small"
              effect="dark"
              type="warning"
            >{{ taskData.executor[0].name }}</el-tag>
          </el-col>
          <el-col v-show="taskData.confirm" :span="12">
            <i class="el-icon-finished icons"/>
            <span>确认人</span>
            <el-tag
              v-if="taskData.confirm.length!==0"
              size="small"
              effect="dark"
              type="success"
            >{{ taskData.confirm[0].name }}</el-tag>
          </el-col>
        </el-row> -->
        <!-- <el-row>
          <span>
            <i class="el-icon-date icons"/>
            起止时间
          </span>
          <span>{{ `${taskData.task_start_time} ~ ${taskData.planned_complete_time}` }}</span>
        </el-row> -->
        <!-- <el-row>
          <span>
            <i class="el-icon-time icons"></i>
            计划工期
          </span>
          <span>吴华娟</span>
        </el-row>-->
        <!-- <el-row> -->
        <!-- <div>
            <div style="float: left;margin-right:10px;">
              <i class="el-icon-tickets icons"/>
              任务描述
            </div>
            <div style="float: left;width: 416px;">
              {{ taskData.task_desc }}
              style="display:inline-block;position: relative;"style="display:inline-block;position: relative;"
              style="display:inline-block;position: relative;"style="display:inline-block;position: relative;"
              style="display:inline-block;position: relative;"style="display:inline-block;position: relative;"
              style="display:inline-block;position: relative;"style="display:inline-block;position: relative;"
            </div>
          </div> -->
        <!-- <div style="display:inline-block;position: relative;">
            <i class="el-icon-tickets icons"></i>
            任务描述
          </div>-->
        <!-- <div class="task_desc" style="display: inline-block;position: absolute;left: 97px;">
            {{taskData.task_desc}}
          </div>-->
        <!-- <el-input type="textarea" :rows="2" style="width: 400px;">{{taskData.task_desc}}</el-input> -->
        <!-- </el-row>
      </div> -->
        <div class="timeBox">
          <!-- <el-divider>
          <i class="el-icon-collection-tag"/>
        </el-divider> -->

          <el-timeline v-show="activeLabel!=='待我执行'">
            <el-timeline-item
              v-for="(activity, index) in logList"
              :key="index"
              :color="color"
              :timestamp="activity.timestamp"
            >
              <div>{{ activity.add_time }}</div>
              <p>{{ activity.content }}</p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>

    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" title="执行完成" width="50%">
      <el-input :rows="3" v-model="textarea" type="textarea" placeholder="请输入内容"/>
      <!-- <div class="taskTime">
        任务开始于：
        <el-date-picker v-model="value1" type="date" size="small" placeholder="选择日期"></el-date-picker>
      </div>-->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { taskExecution, taskConfirm } from '@/api/morningMeeting'

export default {
  name: 'TaskInfo',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    taskData: {
      default() {
        return []
      }
    },
    activeLabel: {
      type: String,
      default() {
        return ''
      }
    },
    logList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      value1: '',
      textarea: '',
      color: '#0bbd87'
    }
  },

  methods: {
    submitDone() {
      this.$confirm('是否确认完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        taskConfirm(this.taskData.id).then(res => {
          this.$emit('cancel')
          this.$emit('searchFormSubmit')
          this.$message({
            type: 'success',
            message: '已成功!'
          })
          this.textarea = ''
        })
          .catch(err => {
            console.log(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    submit() {
      const params = {
        content: this.textarea
      }
      taskExecution(params, this.taskData.id).then(res => {
        // console.log(res)
        this.dialogVisible = false
        this.drawer = false
        this.$emit('searchFormSubmit')
        this.$message({
          type: 'success',
          message: '已成功!'
        })
        this.textarea = ''
      })
        .catch(err => {
          console.log(err)
        })
      this.$emit('cancel')
    },
    handleClose(done) {
      done()
    },
    cancel() {
      this.drawer = false
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss">
.drawerBox {
  padding: 0 15px;
  color: #5f6268;
  font-size: 14px;
  height: 350px;
  .taskTitle {
    font-size: 18px;
    font-weight: 700;
    color: #3a3a3a;

    // text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
    // white-space: wrap;
  }
  .task_desc {
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }
  .icons {
    margin-right: 5px;
    font-size: 20px;
  }

  .el-row {
    margin: 0 10px 20px;
    span {
      margin-right: 5px;
    }
  }
}
.taskTime {
  position: absolute;
  bottom: 20px;
}
.timeBox {
  position: relative;
  padding: 25px 30px;
}
.drawer-content{
  height: 100vh;
  overflow: auto;
  padding-bottom: 50px;
}
</style>
